// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__20Nn2","welcomeBox":"welcomeBox__iikgN"};